module.exports = __webpack_public_path__ + "media/images/phone-receiver-6a99deae36bd3b7871d7e4090d2af679.svg";